import { Slider } from 'primereact/slider';
import React, { FC, useContext, useCallback, useMemo } from 'react';
import { TaskAddEditContext } from '../../../../contexts/TaslAddEditFormContext';

const ProgressFormTab: FC = () => {
    const taskAddEditFormContext = useContext(TaskAddEditContext);

    const handleSliderChange = useCallback((e: { value: number | number[] }) => {
        const value = Array.isArray(e.value) ? e.value[0] : e.value;
        taskAddEditFormContext.setPercentageCompletion(Number(value));
    }, [taskAddEditFormContext.setPercentageCompletion]);

    const percentageStyle = useMemo(() => 
        ({ width: "70px", padding: "7px" }),
        []
    );

    const sliderContainerStyle = useMemo(() => 
        ({ width: "100%", verticalAlign: "center" }),
        []
    );

    const sliderStyle = useMemo(() => 
        ({ height: "7px", borderRadius: "3px" }),
        []
    );

    return (
        <div className="task__create--edit__form--tab__panel--type__task--all">
            <div className="task__create--edit__form--tab__panel--type__task">
                Прогресс выполнения задачи
            </div>
            <div className="task-completion-percentage-container">
                <span style={percentageStyle}>
                    {taskAddEditFormContext.percentageCompletion} %
                </span>
                <div style={sliderContainerStyle}>
                    <Slider
                        className="task-completion-percentage-slider"
                        style={sliderStyle}
                        step={1}
                        value={taskAddEditFormContext.percentageCompletion}
                        onChange={handleSliderChange}
                    />
                </div>
            </div>
        </div>
    );
};

export default ProgressFormTab;